export default "__VITE_ASSET__ln2Dt0pM__"